import { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../auth";
import { freezeMessage, pendingMessage, reconcileMessage } from "../messageOperation";
import { makeUuid, messageOf } from "./DataState";
import { t } from "../preferences";
import { useLocalBack } from "../navigation";

export function MessageComposer({ clientId, clientName, plate = "" }: { clientId: number; clientName: string; plate?: string }) {
  const { state, access } = useAuth();
  const [open, setOpen] = useState(false);
  const [text, setText] = useState("");
  const [template, setTemplate] = useState("free");
  const [sending, setSending] = useState(false);
  const [message, setMessage] = useState<string | null>(null);
  useLocalBack(open, () => setOpen(false));
  if (state.status !== "authenticated") return null;
  const user = state.user;
  if (access?.tariff && !access.tariff.features.includes("manual_messaging")) return null;
  const pending = pendingMessage(user);
  const another = pending && pending.payload.client_id !== clientId;
  const body = pending && !another ? pending.payload.text : text;
  function pick(key: string) {
    setTemplate(key);
    const templates: Record<string, string> = {
      free: "",
      ready: t(`Hurmatli ${clientName}, ${plate} avtomobilingiz tayyor. Kutamiz!`, `Уважаемый(ая) ${clientName}, ваш автомобиль ${plate} готов. Ждём вас!`),
      part: t(`Hurmatli ${clientName}, buyurtma qilgan ehtiyot qismingiz yetib keldi.`, `Уважаемый(ая) ${clientName}, заказанная запчасть поступила.`),
      thanks: t(`Hurmatli ${clientName}, xizmatimizdan foydalanganingiz uchun rahmat!`, `Уважаемый(ая) ${clientName}, спасибо, что воспользовались нашим сервисом!`),
    };
    setText(templates[key]);
  }
  async function send() {
    if (sending || another || !body.trim()) return;
    setSending(true); setMessage(null);
    try {
      const operation = freezeMessage(user, { client_id: clientId, text: body.trim(), send_uuid: makeUuid(), ...(template === "free" ? {} : { template_key: template }) });
      const result = await reconcileMessage(operation);
      setMessage(result.blocked ? t("Mijoz Telegram xabarlarini bloklagan", "Клиент заблокировал сообщения Telegram") : result.status === "sent" ? t("Xabar yuborildi", "Сообщение отправлено") : t("Xabar yuborilmadi", "Сообщение не отправлено"));
      if (result.status === "sent") { setText(""); setOpen(false); }
    } catch (error) { setMessage(messageOf(error)); }
    finally { setSending(false); }
  }
  return <section className="m-mt-4 m-space-y-3">
    <button className="m-secondary-button" onClick={() => setOpen(!open)}>{t("Xabar yuborish", "Отправить сообщение")}</button>
    {message ? <p className="m-error-box" role="status">{message}</p> : null}
    {open ? <div className="m-rounded-xl m-border m-border-border m-p-4 m-space-y-3">
      {another ? <Link className="m-secondary-button" to={`/mechanic/clients/${pending.payload.client_id}`}>{t("Oldingi xabar natijasini tekshirish", "Проверить предыдущее сообщение")}</Link> : <>
        {pending ? <p role="status">{t("Natija noma’lum. Shu xabarni xavfsiz tekshiring.", "Результат неизвестен. Проверьте это же сообщение.")}</p> : null}
        <label className="m-field-label">{t("Shablon", "Шаблон")}<select className="m-text-input" value={template} disabled={Boolean(pending) || sending} onChange={(e) => pick(e.target.value)}>{[["free", t("Erkin matn", "Свободный текст")], ["ready", t("Avtomobil tayyor", "Автомобиль готов")], ["part", t("Ehtiyot qism keldi", "Запчасть поступила")], ["thanks", t("Rahmat", "Благодарность")]].map(([value, label]) => <option key={value} value={value}>{label}</option>)}</select></label>
        <label className="m-field-label">{t("Xabar matni", "Текст сообщения")}<textarea className="m-text-input m-min-h-32" maxLength={1000} value={body} disabled={Boolean(pending) || sending} onChange={(e) => setText(e.target.value)} /></label>
        <button className="m-primary-button" disabled={sending || !body.trim()} onClick={() => void send()}>{sending ? t("Yuborilmoqda…", "Отправка…") : pending ? t("Natijani tekshirish", "Проверить результат") : t("Yuborish", "Отправить")}</button>
      </>}
    </div> : null}
  </section>;
}
